<template>
  <div v-if="productDataset.show_load_more" class="load-more-container">
    <button
      class="load-more ripple-animation ripple-animation--white"
      @click.prevent="
        filterProducts(
          productDataset.load_more_api_url,
          productDataset.load_more_url,
          productDataset.filter_data.tagging_attributes_more_products,
        )
      "
    >
      <span>{{ productDataset.filter_data.more_products }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'load-more-products',
  props: {
    productDataset: { type: Object, required: true },
  },
  methods: {
    /* istanbul ignore next */
    filterProducts(apiUrl, pushState = false) {
      /* istanbul ignore next */
      this.$parent.getData(apiUrl, pushState);
    },
  },
};
</script>
